import { Islands } from '../islands.class';

export const updateIslandPositionsCfn = (islands: Islands): void => {
	const island = islands.getDefaultIsland();

	// no default island exist, return
	if (island === null) return;

	console.log('updateIslandPositionsCfn', island);
	// loop through all island connections to set centerpoints
	island.connections.updateSourceIslandPositions();
};
